<template>
  <div class="partners-chart-skeleton-wrapper">
    <div v-if="isLoading" class="partners-chart-skeleton">
      <div class="partners-chart-skeleton__title flex align-center justify-between">
        <div class="skeleton-line skeleton-line--title"></div>
        <div class="skeleton-line skeleton-line--limit"></div>
      </div>
      <div class="partners-chart-skeleton__chart">
        <div
          v-for="n in 10"
          :key="n"
          class="partners-chart-skeleton__chart-bar flex align-center justify-between"
          :style="{ width: getSkeletonBarWidth(n) }"
        >
          <div class="skeleton-line skeleton-line--name"></div>
          <div class="skeleton-line skeleton-line--sales"></div>
        </div>
      </div>
      <div class="chart-pagination flex align-items-center justify-between">
        <div class="skeleton-line skeleton-line--button"></div>
        <div class="skeleton-line skeleton-line--pagination"></div>
        <div class="skeleton-line skeleton-line--button"></div>
      </div>
    </div>
    <slot v-else></slot>
  </div>
</template>

<script>
export default {
  props: {
    isLoading: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    getSkeletonBarWidth(index) {
      const widths = [100, 95, 80, 65, 50, 40, 40, 30, 25, 20, 15];
      return `${widths[index % widths.length]}%`;
    },
  },
};
</script>

<style lang="scss" scoped>
.partners-chart-skeleton-wrapper {
  width: 100%;
  min-height: 250px;
  background-color: #ffffff;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
}

.partners-chart-skeleton {
  width: 100%;
  padding: 20px 20px 8px;
  box-sizing: border-box;
}

.partners-chart-skeleton__title {
  margin-bottom: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.skeleton-line {
  background: linear-gradient(90deg, #F1EFEF -24.18%, #F9F8F8 50.26%, #E7E5E5 114.84%);
  background-size: 200% 100%;
  border-radius: 4px;
  animation: shimmer 1.4s infinite;

  &--title {
    width: 20%;
    height: 20px;
  }

  &--limit {
    width: 30%;
    height: 18px;
  }

  &--name {
    width: 50%;
    height: 18px;
  }

  &--sales {
    width: 30%;
    height: 18px;
  }

  &--button {
    width: 100px;
    height: 25px;
  }

  &--pagination {
    width: 100px;
    height: 25px;
  }
}

.partners-chart-skeleton {
  &__chart {
    width: 100%;
    padding-bottom: 10px;

    &-bar {
      border-radius: 0 8px 8px 0;
      padding: 10px 16px;
      min-width: 150px;
      height: 44px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      overflow: hidden;

      &:not(:last-child) {
        margin-bottom: 8px;
      }
    }
  }
}


@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
</style>
